module.exports = __webpack_public_path__ + "static/img/ordernull.ea5da961.png";